import { initSection } from '../../core/shopify/init-section/index.js';
const NAMESPACE = '.js-simple-content';
initSection(NAMESPACE, (section)=>{
    const block = section.querySelector('.js-simple-content-block');
    if (!block) return {
        unload: null
    };
    // Observe the content block
    const blockObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                blockObserver.unobserve(entry.target);
                entry.target.classList.add('is-revealed');
            }
        });
    }, {
        threshold: [
            0,
            0.1
        ]
    });
    if (block) blockObserver.observe(block);
    return {
        unload: ()=>{
            blockObserver.disconnect();
        }
    };
});
